export const GET_USERS = 'get_users';
export const RESET_USERS = 'reset_users';
export const GET_USER_PROFILE = 'get_user_profile';
export const RESET_USER_PROFILE = 'reset_user_profile';
export const DELETE__USER_PROFILE = 'delete_user_profile';
export const EDIT_USER_PROFILE = 'edit_user_profile';
export const GET_USER_STATUS = 'get_user_status';
export const GET_USER_ROLES = 'get_user_roles';
export const ADD_USER = 'add_user';
export const RESET_USER_ROLES = 'reset_user_roles';
export const RESET_USER_STATUS = 'reset_user_status';
export const GET_NEWUSER_APPLICANTS = 'get_newuser_applicants';
export const RESET_NEWUSER_APPLICANTS = 'reset_newuser_applicants';
